import { gql } from '@apollo/client';

export const FORGOT_CODE = gql`
  mutation forgotCode($Email: String!) {
    forgotCode(Email: $Email)
  }
`;
